import React from 'react'
import styled from '@emotion/styled'

import BasicButton from './button'
import { BrowserUtils } from '../../utils/siteUtils'

const fireTradeFailed = (reason, year = '', make = '', model = '', trim = '', vin = '') => {
  BrowserUtils.clearLastPostMessage()
  const payload = {
    type: 'External_Trade_Error', //
    description: `Vehicle is not eligible${reason ? ' because ' + reason : ''}`,
    year,
    make,
    model,
    trim,
    vin
  }
  BrowserUtils.postMessage(JSON.stringify(payload), '*')
}

export default ({ reason, year, make, model, trim, vin }) => (
  <StyledDiv>
    <BasicButton data-testid={'bi-btn-TIV'} onClick={() => fireTradeFailed(reason, year, make, model, trim, vin || '')}>
      Use Trade-In Value Instead
    </BasicButton>
  </StyledDiv>
)

const StyledDiv = styled.div`
  text-align: center;
`
